import { Controller } from "@hotwired/stimulus";
import { formatAudioTime } from "@/utilities/timing_helpers";

export default class extends Controller {
  static targets = ["audio", "triggerButton", "currentTime", "duration", "progress"];

  connect() {
    this.animationId = null;
    this.audioTarget.addEventListener("loadedmetadata", () => this.updateDuration());
    this.audioTarget.addEventListener("playing", () => this.startProgressLoop());
    this.audioTarget.addEventListener("pause", () => this.stopProgressLoop());
    this.audioTarget.addEventListener("ended", () => this.resetPlayer());

    if (this.audioTarget.readyState >= 1) this.updateDuration();
  }

  disconnect() {
    this.stopProgressLoop();
    this.audioTarget.pause();
  }

  toggle(event) {
    if (this.audioTarget.paused) {
      this.audioTarget.play();
      event.currentTarget.dataset.paused = false
    } else {
      this.audioTarget.pause();
      event.currentTarget.dataset.paused = true
    }
  }

  seek() {
    const time = (this.progressTarget.value / 100) * this.audioTarget.duration;
    this.audioTarget.currentTime = time;
    this.updateProgress();
  }

  startProgressLoop() {
    const tick = () => {
      this.updateProgress();
      this.animationId = requestAnimationFrame(tick);
    };
    this.animationId = requestAnimationFrame(tick);
  }

  stopProgressLoop() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }

  updateProgress() {
    const { currentTime, duration } = this.audioTarget;
    if (!duration) return;

    const percent = (currentTime / duration) * 100;
    this.progressTarget.value = percent;
    this.progressTarget.style.setProperty("--progress", `${percent}%`);
    this.currentTimeTarget.textContent = formatAudioTime(currentTime, duration);
  }

  updateDuration() {
    const duration = this.audioTarget.duration;
    this.durationTarget.textContent = formatAudioTime(duration, duration);
    this.currentTimeTarget.textContent = formatAudioTime(0, duration);
  }

  resetPlayer() {
    this.triggerButtonTarget.dataset.paused = true;
    this.progressTarget.value = 0;
    this.progressTarget.style.setProperty("--progress", "0%");
    this.currentTimeTarget.textContent = formatAudioTime(0, this.audioTarget.duration);
  }
}
